import React from "react";
import { Card } from "react-bootstrap";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3d from 'highcharts/highcharts-3d';

// Inisialisasi modul 3D untuk Highcharts
// Cukup jalankan sekali di level aplikasi
Highcharts3d(Highcharts);

// Helper function untuk mengubah format mata uang ke angka
const parseRevenue = (revenue: string): number => {
    return parseFloat(revenue.replace(/[^0-9.-]+/g, "")) || 0;
};

// Mendefinisikan tipe data yang relevan untuk komponen ini
interface ReportRoomDataV4 {
    room_type: string;
    revenue: string;
    room_nights: number;
    // V4 sepertinya tidak memiliki warna, tapi kita siapkan propertinya
    color?: string;
}

// Mendefinisikan props untuk komponen chart
interface RoomHighChart3DProps {
    title: string;
    data: ReportRoomDataV4[];
    dataKey: 'room_nights' | 'revenue';
    valueFormatter?: (value: number) => string;
}

const RoomHighChart3D: React.FC<RoomHighChart3DProps> = ({ title, data, dataKey, valueFormatter }) => {

    // Transformasi data mentah ke format yang dibutuhkan oleh Highcharts series
    const chartData = data.map(item => ({
        name: item.room_type, // Menggunakan 'room_type' sesuai data source
        y: dataKey === 'revenue' ? parseRevenue(item.revenue) : item.room_nights,
        color: item.color || undefined
    }));

    // Konfigurasi lengkap untuk Highcharts
    const options: Highcharts.Options = {
        chart: {
            type: 'pie',
            backgroundColor: 'transparent',
            options3d: {
                enabled: true,
                alpha: 45, // Sudut kemiringan chart
            }
        },
        title: {
            text: title,
            align: 'center',
            style: {
                fontSize: '16px',
                fontWeight: 'bold',
            }
        },
        tooltip: {
            // Menampilkan detail saat kursor diarahkan ke potongan chart
            formatter: function () {
                const point = this.point as any;
                const value = this.y || 0;
                const formattedValue = valueFormatter ? valueFormatter(value) : value.toLocaleString();

                return `<b>${point.name}</b>: ${formattedValue} (${this.percentage?.toFixed(2)}%)`;
            }
        },
        plotOptions: {
            pie: {
                allowPointSelect: true,
                cursor: 'pointer',
                depth: 45,       // Ketebalan efek 3D
                innerSize: '60%',// Ukuran lubang untuk efek doughnut
                dataLabels: {
                    // Label diaktifkan untuk ditampilkan langsung pada chart
                    enabled: true,
                    format: '<b>{point.name}</b>',
                },
            }
        },
        series: [{
            type: 'pie',
            name: title,
            data: chartData
        }],
        credits: {
            // Menonaktifkan logo Highcharts
            enabled: false
        }
    };

    return (
        <Card className="h-100 shadow">
            <Card.Body>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                    containerProps={{ style: { height: '350px', width: '100%' } }}
                />
            </Card.Body>
        </Card>
    );
};

export default RoomHighChart3D;